// src/store.js
import { configureStore } from '@reduxjs/toolkit';
import statisticReducer from './slices/statistic';
import historyReducer from './slices/history';
import continentStatisticReducer from './slices/contientStatistic';

export const store = configureStore({
  reducer: {
    statistic: statisticReducer,
    history: historyReducer,
    continentStatistic: continentStatisticReducer,
    // add other reducers here
  },
});
